export const mockData = {
  services: [
    {
      id: 1,
      title: 'Trademark Registration',
      description: 'Secure your brand identity with our expert trademark registration services. We handle all the paperwork and filing to ensure your brand is protected.',
      icon: 'Shield',
      features: ['Fast Processing', 'Expert Guidance', 'Affordable Rates']
    },
    {
      id: 2,
      title: 'Copyright Registration',
      description: 'Protect your original creative works with comprehensive copyright registration. Safeguard your intellectual property rights.',
      icon: 'FileText',
      features: ['Quick Filing', 'Legal Protection', 'Peace of Mind']
    },
    {
      id: 3,
      title: 'Business Formation',
      description: 'Start your business the right way with our business formation services. We help you set up your company structure legally and efficiently.',
      icon: 'Building2',
      features: ['Complete Setup', 'Legal Compliance', 'Fast Turnaround']
    },
    {
      id: 4,
      title: 'Trademark Search',
      description: 'Conduct thorough trademark searches to avoid conflicts. Our comprehensive search identifies potential issues before you file.',
      icon: 'Search',
      features: ['Comprehensive Search', 'Conflict Detection', 'Expert Analysis']
    },
    {
      id: 5,
      title: 'Amazon Brand Registry',
      description: 'Protect your brand on Amazon with our Brand Registry services. We guide you through enrollment and help secure your presence.',
      icon: 'ShoppingBag',
      features: ['Brand Protection', 'Fast Enrollment', 'Expert Support']
    }
  ],
  pricingPlans: [
    {
      id: 1,
      name: 'Basic',
      price: 45,
      features: [
        'Case Review',
        'Case Filing',
        'Basic Search',
        'State E-Filing',
        'Trademark Secured'
      ],
      notice: 'Streamlined trademark support with expert guidance through every stage of the process',
      popular: false
    },
    {
      id: 2,
      name: 'Deluxe',
      price: 149,
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured'
      ],
      notice: 'Professional assistance designed to keep your filing organized clear and properly managed',
      popular: false
    },
    {
      id: 3,
      name: 'Premium',
      price: 395,
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Secured',
        'Trademark Alert'
      ],
      notice: 'Comprehensive support approach with detailed review strategic guidance and continued assistance',
      popular: true
    },
    {
      id: 4,
      name: 'Elite',
      price: 595,
      features: [
        'Case Review',
        'Case Filing',
        'Direct Hit Search',
        'Trademark Alert',
        'Trademark Secured'
      ],
      notice: 'Elevated trademark service experience with dedicated experts focused on accuracy and confidence',
      popular: false
    }
  ],
  testimonials: [
    {
      id: 1,
      name: 'Sarah Mitchell',
      role: 'Founder of Everglow Skincare',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
      text: 'Brand Name made the trademark registration process a breeze. The team was incredibly professional, and they handled everything efficiently. I couldn\'t be happier with their service and the peace of mind it\'s given my business.'
    },
    {
      id: 2,
      name: 'Marcus Johnson',
      role: 'Creative Director at PixelCraft Studio',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
      text: 'I needed to protect my original artwork, and Brand Name was the perfect partner. Their fast and affordable copyright registration service ensured my work was protected, and their team kept me informed every step of the way.'
    },
    {
      id: 3,
      name: 'Clara Williams',
      role: 'CEO of Purely Organic Foods',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400',
      text: 'Starting my business was a challenge, but Brand Name made it simple. From registering my company to setting up everything I needed, they offered seamless support. I\'m now legally set up and ready to grow!'
    },
    {
      id: 4,
      name: 'David Chen',
      role: 'Owner of TechVision Innovations',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400',
      text: 'I didn\'t want any surprises when registering my trademark, so I turned to Brand Name for a thorough search. Their team found potential conflicts I had missed, saving me a lot of future trouble. Highly recommend their expertise!'
    },
    {
      id: 5,
      name: 'Emily Rodriguez',
      role: 'Founder of BrightTech Gadgets',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400',
      text: 'I needed help registering my brand with Amazon, and Brand Name provided outstanding service. They guided me through every step and got my brand up and running in no time, protecting my business on the world\'s largest marketplace.'
    },
    {
      id: 6,
      name: 'Robert Anderson',
      role: 'Managing Partner at Anderson Legal Group',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
      text: 'As an attorney myself, I appreciate the meticulous attention to detail Brand Name brings to trademark registration. Their process is thorough, efficient, and backed by real expertise. I recommend them to all my clients.'
    },
    {
      id: 7,
      name: 'Sophia Martinez',
      role: 'Designer & Founder of Luxe Interiors',
      image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400',
      text: 'The copyright protection Brand Name provided for my design portfolio was exactly what I needed. They were responsive, knowledgeable, and made the entire process stress-free. My creative work is now fully protected.'
    },
    {
      id: 8,
      name: 'James Thompson',
      role: 'E-commerce Entrepreneur',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400',
      text: 'Brand Name helped me navigate the complex world of Amazon Brand Registry. Their guidance was invaluable, and now my products are protected with enhanced brand controls. Worth every penny!'
    }
  ],
  stats: [
    {
      id: 1,
      value: '100%',
      label: 'Client Satisfaction'
    },
    {
      id: 2,
      value: '24/7',
      label: 'Dedicated Support'
    },
    {
      id: 3,
      value: '100%',
      label: 'Affordable Rates & Quick Turnaround'
    }
  ],
  processSteps: [
    {
      id: 1,
      title: 'Submit Your Details',
      description: 'Share your trademark information through our simple form and get instant expert guidance.'
    },
    {
      id: 2,
      title: 'We Handle Everything',
      description: 'Our team conducts comprehensive searches, prepares documents, and files with the USPTO.'
    },
    {
      id: 3,
      title: 'Get Protected',
      description: 'Receive your registered trademark certificate and enjoy complete brand protection.'
    }
  ]
};
